import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';
import publicPath from '../../utils/publicPath';

export default () => {
  const { typography, breakpoints, spacing, colors } = useTheme();

  return {
    hero: ({ mobile, desktop }) => {
      return css`
        display: grid;
        align-items: end;
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        grid-template-rows: minmax(36vh, 350px) auto;
        align-items: center;
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 30%,
            rgba(1, 30, 65) 80%,
            rgba(1, 30, 65) 100%
          ),
          url('${mobile.src}') 0 0 no-repeat;
        background-size: cover;

        align-content: space-around;
        padding: 0 ${spacing.s};
        padding-top: 106px;

        ${breakpoints.l} {
          background: url(${desktop.src}) 0 0 no-repeat;
          background-size: cover;
          background-position: top center;
          padding-top: 8rem;
          padding-bottom: 2rem;
          margin-top: 6rem;

          &::after {
            background: right 0 no-repeat;
            background-image: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0) 40%,
                rgba(1, 30, 65) 85%,
                rgba(1, 30, 65) 100%
              ),
              url(${publicPath(
                '/images/desktop/recommendations/keyline-provider.svg'
              )}),
              url(${publicPath('/images/common/play-watermark.svg')});
            background-position: right 20vh, right 20vh;
            background-repeat: no-repeat, no-repeat;
          }
        }
        @media (min-device-width: 1024px) and (max-device-width: 1196px) {
          padding-top: 5rem;
          padding-bottom: 3rem;
        }
        @media (min-device-width: 810px) and (max-device-width: 821px) {
            padding-top: 8rem;
            padding-bottom: 2rem;
          }
        ${breakpoints.mm_s_m} {
          padding-top: 8rem;
          padding-bottom: 5rem;
        }
        ${breakpoints.mm_xs_s} {
          padding-top: 12rem;
        }
      `;
    },
    providerWrapper: css`
      display: flex;
      justify-content: flex-start;
      grid-row-gap: 2.6rem;
      margin-left: calc(100% - 96%) !important;
    `,
    infoWrapper: (hasPadding, titleHeight, isvenue) => css`
      position: relative;
      max-width: 100%;
      margin-bottom: 4rem;

      ${breakpoints.m} {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        grid-row-gap: ${spacing.s};
        ${isvenue === 'false'
          ? css`
              margin-bottom: 2rem;
            `
          : css`
              margin: 0 auto calc(100vh - 88vh) auto;
            `}
        width: 100%;
        max-width: 951px;
      }

      ${breakpoints.l} {
        margin-bottom: 5rem;
        margin-top: 2rem;
        // if title has 2 lines
        ${titleHeight < 550 &&
        css`
          margin-top: 2rem;
        `}
      }

      ${breakpoints.xl} {
        top: 0;
        grid-template-columns: auto;
        max-width: 951px;
        width: 100%;
        padding: 0;
      }
      @media screen and (min-width: 1761px) {
        margin-left: 20rem;
      }
    `,
    textWrapper: (hasLoaded, isVenue) => css`
      @media screen and (min-width: 425px) {
        ${isVenue === 'true' &&
        css`
          margin-bottom: 4rem;
        `}
      }
      position: relative;
      z-index: 1;
      align-self: end;
      opacity: 0;
      transition: opacity 0.5s;
      width: 90vw;
      max-width: 590px;
      margin: 0 0 0 125px;

      @media screen and (min-width: 1281px) and (max-width: 1760px) {
        margin-left: 15rem;
      }

      ${hasLoaded &&
      css`
        opacity: 1;
      `}

      &.fadeOut {
        opacity: 0.3;
      }

      ${breakpoints.mm_s_m} {
        margin: 0;
      }
      ${breakpoints.mm_l_xl} {
        margin: 0 0 0 30px;
      }
      ${breakpoints.mm_m_l} {
        margin: 0 0 0 -7px;
        align-self: center;
      }
      ${breakpoints.mm_s_m} {
        margin: 0 0 0 -7px;
      }
      ${breakpoints.mm_xs_s} {
        margin: 0 auto 30px;
      }
    `,
    mainText: css`
      ${typography.headings[3].mobile};
      text-transform: capitalize;
      z-index: 2;
      text-align: left !important;
      position: relative;
      color: ${colors.white};
      transition: opacity 0.5s;
      padding-bottom: 6px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      -webkit-box-orient: vertical;
      max-width: 540px !important;
      width: 100% !important;
      font-style: normal !important;
      margin: 0 !important;

      ${breakpoints.l} {
        ${typography.headings[1].desktop};
        max-width: 50%;
        padding-bottom: 7px;
        font-size: 3.95rem !important;
      }
    `,
    distance: css`
      margin-top: ${spacing.s};
      padding: 0;
      color: ${colors.white};
      background: none;
      font-weight: normal;
      letter-spacing: 0.02em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      float: left;
      max-width: 95%;
      font-size: 18px;
      text-transform: capitalize;
      text-decoration: underline;
      justify-content: flex-start;

      ${breakpoints.m} {
        max-width: 100%;
        text-decoration: underline;
      }

      & span {
        font-size: 18px;
        padding-left: 0;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &:not(:disabled):hover,
      &:not(:disabled):focus:not(:focus-visible) {
        background: none;
        color: ${colors.white};
      }
      &:hover:not(:focus-visible) {
        background-color: none;
        color: ${colors.white};
        font-family: 'FS Dillon Bold';
        transition: 'ease-in 1s';
      }
      ${breakpoints.s} {
        &:focus-visible {
          outline: none;
          border-bottom: 2px solid ${colors.border_black};
          color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          text-decoration: none;
          width: fit-content;
        }
        &:focus-visible:hover {
          color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
          font-family: 'FS Dillon Bold';
          transition: 'ease-in 1s';
        }
      }
    `,
    info: css`
      ${typography.body.mobile};
      display: flex;
      justify-content: flex-start;
      margin: ${spacing.xs} auto;
      font-size: 0.875rem;
      ${breakpoints.m} {
        margin: 0;
        max-width: 100%;
      }
    `,
    backLink: css`
      color: ${colors.white};
      margin: ${spacing.s} 0;
      text-decoration: none;
      display: flex;
      align-items: center;
      font-weight: normal;
      padding: 0;
      ${breakpoints.s} {
        &:focus-visible {
          outline: none;
          border-bottom: 2px solid ${colors.border_black};
          color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          width: fit-content;
        }
      }
      &:hover{
        text-decoration: underline;
      }
    `,
    heroLogo: css`
      width: 80px;
      height: 80px;
      flex: 0 0 80px;
      max-width: 80px;
      padding: 5px;
      border-radius: 100%;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      order: 2;
      margin-bottom: 8px;

      ${breakpoints.m} {
        width: 88px;
        height: 88px;
        padding: 0px;
        max-width: 88px;
        margin-bottom: 18px;
      }
    `,
  };
};